import { useEffect } from 'react';
import { Outlet } from 'react-router';

import { TENANT_CONST } from '@/constant';
import { useUnleash } from '@/package';
import { useTenantStore } from '@/store';
import type { Tenant, TenantLimitSize } from '@/type';

const TIER_LIMIT_MAP: {
  [key in Tenant['tier']]: string;
} = {
  [TENANT_CONST.TIER.FREETIER]: 'vuex.miri.freeLimit',
  [TENANT_CONST.TIER.STANDARD]: 'vuex.miri.enterpriseLimit',
};

const Home = () => {
  const { getVariantPayloadValue, updateContext } = useUnleash();
  const { currentTenantID, getCurrentTenant, setLimitSize } = useTenantStore();

  useEffect(() => {
    const tenant = getCurrentTenant();

    const payload = getVariantPayloadValue<TenantLimitSize>(
      TIER_LIMIT_MAP[tenant?.tier ?? TENANT_CONST.TIER.FREETIER] ??
        TIER_LIMIT_MAP[TENANT_CONST.TIER.FREETIER],
    )!;

    setLimitSize(payload);
  }, [currentTenantID, getVariantPayloadValue]);

  useEffect(() => {
    const tenant = getCurrentTenant();

    updateContext({
      sessionId: tenant?.tenantID ?? '',
    });
  }, [currentTenantID]);

  return <Outlet />;
};

export default Home;
